import Utils from "../utils.class";
const {jQuery: $} = window;

export default class PieChartCounter {
    #theme;
    #$counters;
    #sel;

    constructor(theme) {
        this.#sel = ".elementor-widget-ticker-counter-wrap";
        this.#theme = theme;
        this.#$counters = $(this.#sel);

        $(window).on('load', () => this.setup());
        $(window).on("pieAnimationStart", (event, el) => this.start(event, el));
    }

    setup() {
        const $components = $(this.#sel);
        const options = {
            root: null,
            rootMargin: "0px",
            scrollMargin: "-30% 0px -30% 0px",
            threshold: 1.0,
        };
        // const refitViewBox = function (svgEl, textEl, divEl, padding = 8) {
        //
        //     const start = divEl.getAttribute("data-start");
        //     const end = divEl.getAttribute("data-end");
        //     const prefix = divEl.getAttribute("data-prefix");
        //     const suffix = divEl.getAttribute("data-suffix");
        //     console.log(end)
        //
        //
        //     const formatted = Utils.commaSeparateNumber(Math.floor(end));
        //     const formattedStart = Utils.commaSeparateNumber(Math.floor(start));
        //
        //     textEl.textContent  = prefix + formatted;
        //     console.log(textEl);
        //     const bb = textEl.getBBox();
        //     svgEl.setAttribute('viewBox', [
        //         bb.x - padding,
        //         bb.y - padding,
        //         bb.width  + padding * 2,
        //         bb.height + padding * 2
        //     ].join(' '));
        //
        //     textEl.innerText  =prefix + formattedStart;
        //     textEl.setAttribute('style', [
        //         ['visibility','visible']
        //     ]);
        // }
        //
        // $components.each(function (i, el) {
        //     const svgEl = el.querySelector('svg');
        //     const divEl = el;
        //     refitViewBox(svgEl, svgEl.querySelector('text'), divEl);
        // });

        const animatePicker = function (entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let el = entry.target;
                    if (entry.intersectionRatio >= 0.75) {
                        $(el).trigger("pieAnimationStart", [el]);
                    }
                }
            });

        }

        const observer = new IntersectionObserver((entries, observer) => animatePicker(entries, observer), options);

        $components.each(function (i, el) {
            observer.observe(el);
        });
    }

    start(event, el) {
        const $el = $(el);

        if($el.is(this.#sel) && !$el.data("finished")) {
            Utils.log("Start:", el);
            const start = $el.data("start");
            const end = $el.data("end");
            const prefix = $el.data("prefix");
            const suffix = $el.data("suffix");
            const $value = $el.find(".pie-chart__text");
            const $pie = $el.find(".pie-chart__circle--active");
            const duration = $el.data("duration");

            $el.data("finished", true);
            $value[0].childNodes[1].textContent = start;

            $({countNum: start}).animate({
                countNum: end
            },{
                duration: (duration * 1000),
                easing: 'linear',
                step: function () {
                    const formatted = Utils.commaSeparateNumber(Math.floor(this.countNum));
                    // $value.text(prefix + formatted + suffix);
                    $value[0].childNodes[1].textContent = formatted;
                    $pie.css('strokeDasharray', `${this.countNum} 100`);
                },
                complete: function () {
                    const formatted = Utils.commaSeparateNumber(Math.floor(this.countNum));
                    // $value.text(prefix + formatted + suffix);
                    $value[0].childNodes[1].textContent = formatted;
                    $pie.css('strokeDasharray', `${this.countNum} 100`);
                }
            }, 0);
        }
    }
}